export const BackIcon = () => <i className="fa-solid fa-arrow-left" />
